import Header from '@propertypal/shared/src/resources/images/pn-devs/golden-gate/header.png';
import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Text, TextProps } from '../../typography';
import DevelopmentContent, { DevelopmentSection } from './DevelopmentContent.pn';
import { DevHeaderImg } from './DevelopmentContent.style.pn';

interface GoldenGateContentProps {}

const GoldenGateContent: React.FC<GoldenGateContentProps> = () => {
  const theme = useTheme();

  const textProps = useMemo(() => {
    const p: TextProps = {
      fontSize: 17,
      lineHeight: 25,
      mt: 8,
      mb: 16,
      color: theme.textDark,
    };
    return p;
  }, [theme]);

  return (
    <div data-testid="golden-gate-content">
      <DevelopmentContent bg={theme.background}>
        <DevelopmentSection narrow>
          <DevHeaderImg src={Header.src} alt="Golden Gate Development" />
          <Text {...textProps}>
            Golden Gate is an exquisite development of superbly detailed, luxury homes, situated just off the highly
            sought after Upper Road in Greenisland.
          </Text>
          <Text {...textProps}>
            With a superb range of outstanding family homes, all cleverly incorporated in a delightfully planned site
            layout, this magnificent development offers an unrivalled specification and introduces a whole new choice of
            stylish family living for this idyllic part of County Antrim.
          </Text>
          <Text {...textProps}>
            Perfectly located just off Downview Avenue, this unique new development of bespoke, contemporary and
            traditional homes exudes a very grandiose atmosphere and rubs shoulders with some of the finest residences
            in Greenisland. These excellent homes in this prestigious address offer convenience to both Carrickfergus
            and Belfast and many leading grammar and primary schools.
          </Text>
          <Text {...textProps}>
            For those interested in sporting, leisure and recreational facilities, the location of Golden Gate could not
            be better. Greenisland boasts an excellent Golf Course and rugby club, along with many beautiful parks and
            coastal walks at Newtownabbey. The ideal location on the edge of Geenisland ensures that residents could not
            be better placed to enjoy all the superb facilities that this wonderful part of County Antrim has to offer.
          </Text>
          <Text {...textProps}>
            <strong>SPECIFICATION</strong>
          </Text>
          <Text {...textProps}>
            KITCHENS AND UTILITY (Where Applicable)
            <br />- Impressive high quality units with choice of doors and handles, work top with wiring for
            underlighting
            <br />- Integrated appliances to include gas hob, stainless steel electric oven, extractor hood, integrated
            dishwasher and integrated fridge/freezer
            <br />- Houses plumbed for washing machine and dryer
          </Text>
          <Text {...textProps}>
            BATHROOM, ENSUITE AND CLOAKROOM
            <br />- Contemporary white sanitary ware with chrome fittings
            <br />- Heated towel rail to bathroom and Ensuite
            <br />- Thermostatically controlled shower over bath with screen door (where applicable, if no separate
            shower cubicle)
            <br />- Showers in ensuites with thermostatically controlled fittings.
          </Text>
          <Text {...textProps}>
            FLOOR COVERING AND TILING
            <br />- Engineered Solid Oak floor to entrance hall, family/dining and sun room (if applicable)
            <br />- Ceramic tiled floor to kitchen area, utility, WC, Bathrooms and ensuites.
            <br />- Tiling to all shower cubicles
            <br />- Full height tiling around bath areas
            <br />- Splash back tiling to wash hand basins and above kitchen worktops
            <br />- Carpets to living room, bedrooms, stairs and landing
          </Text>
          <Text {...textProps}>
            EXTERNAL FEATURES
            <br />- Front and rear gardens turfed
            <br />- Rear garden enclosed with close boarded fencing
            <br />- uPVC double glazed windows
            <br />- Driveways to be finished in granite stone
            <br />- Brick pavior path to the front of the house
          </Text>
          <Text {...textProps}>
            INTERNAL FEATURES
            <br />- Entrance door with 5 point locking system
            <br />- Natural gas fired central heating system
            <br />- Walls and ceilings painted throughout – white emulsion to ceilings and cream to all walls
            <br />- White painted skirting and architraves
            <br />- White painted internal doors with quality ironmongery
            <br />- Comprehensive range of electrical points, sockets, television and telephone points (with BT
            extension to living area)
            <br />- Recessed down-lights to kitchen, Ensuite and bathroom
            <br />- Mains smoke and carbon monoxide detectors
            <br />- Alarm system installed
          </Text>
          <Text {...textProps}>
            COMMON LANDSCAPED AREA
            <br />- There will be walled and landscaped entrance as well as a number of landscaped amenity areas to be
            maintained by a management company and paid for by way of an annual management charge.
          </Text>
          <Text {...textProps}>
            BUILDING WARRANTY
            <br />- Each home will be issued with a NHBC 10 year warranty certificate.
          </Text>
        </DevelopmentSection>
      </DevelopmentContent>
    </div>
  );
};

export default GoldenGateContent;
